import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  message,
  Card,
  Col,
  Spin,
  Row,
  Tooltip,
  Image,
  Dropdown,
  Select,
  DatePicker,
  Pagination,
  InputNumber,
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
  SearchOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileImageOutlined,
  FileUnknownOutlined,
  ClockCircleOutlined,
  MessageOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { FaPen, FaTrashAlt } from "react-icons/fa";
import { hasPermission } from "../../utils/HasPermission";
import dayjs, { Dayjs } from "dayjs";
import { RiAddBoxFill, RiRefreshLine } from "react-icons/ri";
import AddJobApplicationModal from "./Add";
import { ColumnType } from "antd/es/table";
import {
  getAllJobApplications,
  deleteJobApplication,
  deleteJobDocumentImage,
  createStatus,
  getStatus,
  getAllSources,
  updateJobApplication,
  getSingleJobApplication,
  deleteDescription,
  getRawDataLog,
  deleteFilter,
  addFilter,
  getFilter,
  updateFilter,
  getJobapplicationFromWebsite,
} from "../../utils/API";
import EditJobApplicationModal from "./Edit";
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "react-beautiful-dnd";
import { ColorPicker } from "antd";
import * as Icons from "@ant-design/icons";
import { AuthContext } from "../../Auth/AuthContext";
import { useDispatch } from "react-redux";
import {
  updateJobApplicationStatus,
  setJobApplications,
} from "../store/slice/jobApplicationSlice";
import type { AppDispatch } from "../store/index";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import TiptapImage from "@tiptap/extension-image";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Placeholder from "@tiptap/extension-placeholder";
import Heading from "@tiptap/extension-heading";
import BulletList from "@tiptap/extension-bullet-list";
import { autoRegisterCurrentPageColumns } from "../../utils/emailTemplateColumns";
import { getErrorMessage } from "../../utils/getErrorMessage";

interface JobApplication {
  _id: string;
  full_name: string;
  email: string;
  city: string;
  technology: string;
  total_experience: number;
  relevant_experience: number;
  current_ctc: number;
  expected_ctc: number;
  phone_number: string;
  date: string;
  resume: string;
  key: string;
  source: string;
  jobDesc?: string;
  remark?: string;
  document: string[];
  status: string[];
}

const SourceBadge = ({ source, color }: any) => (
  <span
    style={{
      backgroundColor: color ? `${color}1A` : "#f5f5f5", // subtle bg tint
      color: color || "#262626", // darker text for better contrast
      fontSize: "12px",
      padding: "3px 10px",
      borderRadius: "6px", // smoother rounded look
      fontWeight: 600,
      display: "inline-flex",
      alignItems: "center",
      lineHeight: 1.4,
    }}
  >
    {source}
  </span>
);

interface Status {
  _id: string;
  name: string;
  color: string;
  slug?: string;
  createdAt?: string;
  __v?: number;
}

const JobApplicationPage = () => {
  const { authData } = useContext(AuthContext);
  const userId = authData.user?._id;
  const isDeveloper = authData.roleId?.roleId === 2;
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/job-application/";
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [currentTask, setCurrentTask] = useState<JobApplication | null>(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isAddTaskModalOpen, setIsAddTaskModalOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState<JobApplication[]>([]);
  const [selectedRecord, setSelectedRecord] = useState<JobApplication | null>(
    null,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState<JobApplication[]>([]);
  const [dropdownsClosed, setDropdownsClosed] = useState(0); // Counter to force close dropdowns
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [timeFilter, setTimeFilter] = useState<
    "today" | "thisMonth" | "lastMonth" | "custom" | undefined
  >(undefined);
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [tempEndDate, setTempEndDate] = useState<Dayjs | null>(null);
  const [tempStartDate, setTempStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [statusFilter, setStatusFilter] = useState<string | undefined>();
  const [optionStatus, setoptionStatus] = useState([]);
  const [descriptionModalOpen, setDescriptionModalOpen] = useState(false);
  const [descriptionLoading, setDescriptionLoading] = useState(false);
  const [descriptionData, setdescriptionData] = useState<any[]>([]);
  const [CurrentDescriptionDataId, setCurrentDescriptionDataId] = useState<
    string | null
  >(null);
  const [statuses, setStatuses] = useState<
    Array<{
      _id: string;
      name: string;
      color: string;
      slug: string;
      createdAt: string;
      __v: number;
    }>
  >([]);
  const [sources, setSources] = useState<Array<string>>([]);
  const [JobApplicationModal, setJobApplicationModal] = useState(false);
  const optionsNumber = Array.from({ length: 30 }, (_, i) => i + 1);
  const [descValue, setDescValue] = useState("");
  const [uploadedImages, setUploadedImages] = useState<File[]>([]);
  const [newDescription, setNewDescription] = useState<{
    date: Dayjs | null;
    description: string;
    nextActionDate: Dayjs | null;
  }>({
    date: dayjs(),
    description: "",
    nextActionDate: dayjs(),
  });
  const [isOverflow, setIsOverflow] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [currentLogId, setCurrentLogId] = useState<string | null>(null);
  const [selectedLogs, setSelectedLogs] = useState<any[]>([]);
  const [logsPagination, setLogsPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [logLoading, setLogLoading] = useState(false);
  const [logSearchText, setLogSearchText] = useState("");
  const modalScrollRef = useRef<HTMLDivElement>(null);
  const [dataSource, setDataSource] = useState<any>([]);
  const [showAddStatus, setShowAddStatus] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [newStatusColor, setNewStatusColor] = useState("#1890ff");
  const [selectedIcon, setSelectedIcon] = useState("");
  const [favouriteFilters, setFavouriteFilters] = useState<any[]>([]);
  const [selectedFav, setSelectedFav] = useState<number | null>(null);
  const [favName, setFavName] = useState("");
  const [error, setError] = useState("");
  const [selectedSource, setSelectedSource] = useState<string[] | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string[] | null>(null);
  const [start, setStart] = useState<number | undefined>();
  const [end, setEnd] = useState<number | undefined>();
  const [selectedPosition, setSelectedPosition] = useState<string | null>(null);

  const [minCTC, setMinCTC] = useState<number | undefined>();
  const [maxCTC, setMaxCTC] = useState<number | undefined>();

  const scrollRef = useRef<HTMLDivElement>(null);
  const previewRefs = useRef<(HTMLDivElement | null)[]>([]);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [overflowIndexes, setOverflowIndexes] = useState<number[]>([]);

  const [currentFilters, setCurrentFilters] = useState<any>({});

  const technologyOptions: Record<string, string[]> = {
    "Frontend Developer": [
      "HTML5",
      "CSS3",
      "JavaScript (ES6+)",
      "TypeScript",
      "React",
      "Next.js",
      "Angular",
      "Vue.js",
      "Nuxt.js",
      "Svelte",
      "SvelteKit",
      "Tailwind CSS",
      "Bootstrap",
      "Material UI",
      "Chakra UI",
      "Ant Design",
      "Redux",
      "Zustand",
      "Recoil",
      "Pinia",
      "Vite",
      "Webpack",
      "Jest",
      "React Testing Library",
      "Cypress",
      "Playwright",
      "React Native",
      "Flutter (Web Support)",
      "Astro",
      "Gatsby",
      "GraphQL (Apollo)",
      "Storybook",
      "ESLint",
      "Prettier",
    ],
    "Backend Developer": [
      "JavaScript (Node.js)",
      "TypeScript",
      "Python",
      "Java",
      "C#",
      "PHP",
      "Go",
      "Ruby",
      "Rust",
      "Kotlin",
      "Scala",
      "Node.js",
      "Express.js",
      "NestJS",
      "Django",
      "Flask",
      "FastAPI",
      "Spring Boot",
      "Micronaut",
      "Quarkus",
      "Laravel",
      "Symfony",
      "CodeIgniter",
      "Ruby on Rails",
      "Phoenix (Elixir)",
      "Fiber (Go)",
      "Gin (Go)",
      "Actix (Rust)",
      "Rocket (Rust)",
      "MySQL",
      "PostgreSQL",
      "SQLite",
      "MongoDB",
      "Redis",
      "MariaDB",
      "Oracle DB",
      "MS SQL Server",
      "Cassandra",
      "CouchDB",
      "Firebase Realtime DB",
      "DynamoDB",
      "REST API",
      "GraphQL",
      "gRPC",
      "WebSockets",
      "AWS Lambda",
      "Google Cloud Functions",
      "Azure Functions",
      "Serverless Framework",
      "Docker",
      "Kubernetes",
      "JUnit",
      "PyTest",
      "Mocha",
      "Jest",
      "Supertest",
      "Postman/Newman",
    ],
    "Fullstack Developer": [
      "MERN (MongoDB, Express.js, React, Node.js)",
      "MEAN (MongoDB, Express.js, Angular, Node.js)",
      "MEVN (MongoDB, Express.js, Vue.js, Node.js)",
      "Next.js + Node.js",
      "NestJS + React",
      "RedwoodJS (Fullstack React/GraphQL framework)",
      "Blitz.js (Next.js based fullstack framework)",
      "Django + React",
      "Django + Angular",
      "Flask + React",
      "FastAPI + Vue",
      "Spring Boot + React",
      "Spring Boot + Angular",
      "LAMP (Linux, Apache, MySQL, PHP)",
      "Laravel + Vue.js",
      "Laravel + React",
      "Symfony + React",
      "Ruby on Rails + React",
      "Ruby on Rails + Hotwire",
      "Elixir Phoenix + LiveView",
      "Go + React",
      "Go + Vue",
      "ASP.NET Core + React",
      "ASP.NET Core + Angular",
      "Remix (React Fullstack Framework)",
      "Nuxt.js (Vue Fullstack Framework)",
      "SvelteKit (Svelte Fullstack Framework)",
      "Astro (with React/Vue/Svelte integrations)",
    ],
  };

  // Flatten into one single array
  const allTechnologies = Object.values(technologyOptions).flat();

  const addImage = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.click();

    input.onchange = () => {
      const files = Array.from(input.files || []);
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));

      // Add all images to uploaded images at once
      setUploadedImages((prev) => [...prev, ...imageFiles]);

      // Insert images one by one
      imageFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          editor
            ?.chain()
            .focus()
            .setImage({
              src: reader.result as string,
              alt: file.name,
              title: file.name,
              width: 300,
            })
            .run();
        };
        reader.readAsDataURL(file);
      });
    };
  };
  const handleFilter = () => {
    if (minCTC !== undefined && maxCTC !== undefined && minCTC > maxCTC) {
      alert("Min CTC cannot be greater than Max CTC");
      return;
    }
    // onFilter(minCTC || 0, maxCTC || 0);
  };

  const handleAddStatus = async () => {
    const trimmed = newStatus.trim();
    if (!trimmed) {
      message.error("Status name is required");
      return;
    }

    if (statuses.some((s) => s.name.toLowerCase() === trimmed.toLowerCase())) {
      message.warning("Status already exists");
      return;
    }

    try {
      setLoading(true);

      const response = await createStatus({
        name: trimmed,
        color: newStatusColor,
      });

      if (!response?.data?._id) {
        throw new Error("Invalid response from createStatus");
      }

      const newStatusItem = {
        _id: response.data._id,
        name: trimmed,
        color: response.data.color || newStatusColor,
        slug: response.data.slug || trimmed.toLowerCase().replace(/\s+/g, "-"),
        createdAt: response.data.createdAt || new Date().toISOString(),
        __v: response.data.__v || 0,
      };

      // Add new status to local state
      setStatuses((prev) => [...prev, newStatusItem]);

      // Optional: update local storage with new order
      const updatedOrder = [...statuses.map((s) => s._id), newStatusItem._id];
      localStorage.setItem("statusOrder", JSON.stringify(updatedOrder));

      // Optionally, immediately apply this new status to the current record
      // await handleStatusChange(record._id, newStatusItem.name);

      // Reset input
      setNewStatus("");
      setNewStatusColor("#000000");
      setShowAddStatus(false);

      message.success(`Status "${trimmed}" added successfully`);
    } catch (error: any) {
      console.error("Error adding status:", error);
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to add status",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (textRef.current) {
      setIsOverflow(
        textRef.current.scrollHeight > textRef.current.clientHeight ||
          textRef.current.scrollWidth > textRef.current.clientWidth,
      );
    }
  }, [descriptionData]);

  useEffect(() => {
    const newOverflowIndexes: number[] = [];
    previewRefs.current.forEach((el, idx) => {
      if (el && el.scrollHeight > el.clientHeight) {
        newOverflowIndexes.push(idx);
      }
    });
    setOverflowIndexes(newOverflowIndexes);
  }, [descriptionData]);

  const getStatusBadge = (s: { _id: string; name: string; color?: string }) => {
    if (Array.isArray(s)) {
      return (
        <div className="flex flex-wrap gap-1">
          {s.map((s: any, index: number) => (
            <span
              key={s._id || index}
              style={{
                backgroundColor: s.color ? `${s.color}33` : "#f0f0f0",
                color: s.color || "#000000",
                fontSize: "10px",
                padding: "2px 8px",
                borderRadius: "4px",
                fontWeight: 700,
                display: "inline-block",
              }}
            >
              {s.name}
            </span>
          ))}
        </div>
      );
    }

    // If status is a single object
    return (
      <span
        style={{
          backgroundColor: s?.color ? `${s.color}33` : "#f0f0f0",
          color: s.color || "#000000",
          fontSize: "10px",
          padding: "2px 8px",
          borderRadius: "4px",
          fontWeight: 700,
          display: "inline-block",
        }}
      >
        {s.name}
      </span>
    );
  };
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: false,
        // Don't disable these - let them work normally
        bulletList: {
          HTMLAttributes: {
            class: "bullet-list",
          },
        },
        orderedList: {
          HTMLAttributes: {
            class: "ordered-list",
          },
        },
      }),

      Heading.configure({
        levels: [1, 2, 3],
      }),

      Underline,
      Link.configure({
        openOnClick: true,
        HTMLAttributes: { class: "text-blue-500 underline" },
      }),

      TiptapImage.extend({
        addAttributes() {
          return {
            src: { default: null },
            alt: { default: null },
            title: { default: null },
            width: {
              default: 300,
              renderHTML: (attributes: any) => ({
                width: attributes.width,
                style: `width: ${attributes.width}px; height: auto; max-width: 100%;`,
              }),
            },
            height: { default: "auto" },
          };
        },
      }).configure({
        inline: false,
        HTMLAttributes: {
          class: "rounded-md",
          style: "max-width: 100%; height: auto;",
        },
      }),

      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),

      Placeholder.configure({
        placeholder: "Enter description...",
      }),
    ],

    content: descValue || "",

    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      // const text = editor.getText(); // Get plain text
      setDescValue(html);
    },

    editorProps: {
      handlePaste(view, event) {
        const items = Array.from(event.clipboardData?.items || []);
        let imageProcessed = false;

        for (const item of items) {
          if (item.type.startsWith("image/")) {
            event.preventDefault();
            const file = item.getAsFile();
            if (!file) continue;

            setUploadedImages((prev) => [...prev, file]);

            const reader = new FileReader();
            reader.onload = () => {
              const transaction = view.state.tr.insert(
                view.state.selection.from,
                view.state.schema.nodes.image.create({
                  src: reader.result,
                  alt: "Pasted image",
                  title: "Pasted image",
                  width: 300,
                }),
              );
              view.dispatch(transaction);
            };
            reader.readAsDataURL(file);
            imageProcessed = true;
            break;
          }
        }
        return imageProcessed;
      },

      handleDrop(view, event) {
        if (event.dataTransfer?.files) {
          const files = Array.from(event.dataTransfer.files);
          let imageProcessed = false;

          files.forEach((file) => {
            if (file.type.startsWith("image/")) {
              event.preventDefault();
              imageProcessed = true;

              setUploadedImages((prev) => [...prev, file]);

              const reader = new FileReader();
              reader.onload = () => {
                const coordinates = view.posAtCoords({
                  left: event.clientX,
                  top: event.clientY,
                });

                if (coordinates) {
                  const transaction = view.state.tr.insert(
                    coordinates.pos,
                    view.state.schema.nodes.image.create({
                      src: reader.result,
                      alt: file.name,
                      title: file.name,
                      width: 300,
                    }),
                  );
                  view.dispatch(transaction);
                }
              };
              reader.readAsDataURL(file);
            }
          });

          return imageProcessed;
        }
        return false;
      },
    },
  });

  // Replace the Toolbar component
  const Toolbar = () => {
    if (!editor) return null;

    return (
      <div className="border-b border-gray-200 p-2 flex flex-wrap items-center gap-1 bg-gray-50">
        {/* Text formatting */}

        <Button
          type={editor.isActive("bold") ? "primary" : "default"}
          size="small"
          onClick={() => editor.chain().focus().toggleBold().run()}
          title="Bold"
        >
          <strong>B</strong>
        </Button>
        <div className="flex items-center gap-1 pr-2">
          <Button
            type={editor.isActive("bulletList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            title="Bullet List"
          >
            • List
          </Button>
          <Button
            type={editor.isActive("paragraph") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().setParagraph().run()}
            title="Paragraph"
          >
            P
          </Button>
          {/* <Button
            type={editor.isActive("orderedList") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            title="Numbered List"
          >
            1. List
          </Button> */}

          {/* <Button
            type={editor.isActive("italic") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleItalic().run()}
            title="Italic"
          >
            <em>I</em>
          </Button>
          <Button
            type={editor.isActive("underline") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            title="Underline"
          >
            <u>U</u>
          </Button>
          <Button
            type={editor.isActive("strike") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().toggleStrike().run()}
            title="Strikethrough"
          >
            <s>S</s>
          </Button> */}
        </div>

        {/* Headings */}
        {/* <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          <Button
            type={
              editor.isActive("heading", { level: 1 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 1 }).run()
            }
            title="Heading 1"
          >
            H1
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 2 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
            title="Heading 2"
          >
            H2
          </Button>
          <Button
            type={
              editor.isActive("heading", { level: 3 }) ? "primary" : "default"
            }
            size="small"
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 3 }).run()
            }
            title="Heading 3"
          >
            H3
          </Button>
          <Button
            type={editor.isActive("paragraph") ? "primary" : "default"}
            size="small"
            onClick={() => editor.chain().focus().setParagraph().run()}
            title="Paragraph"
          >
            P
          </Button>
        </div> */}

        {/* Lists */}

        {/* Links */}
        {/* <div className="flex items-center gap-1 border-r border-gray-300 pr-2">
          {showLinkInput ? (
            <div className="flex items-center gap-1">
              <Input
                size="small"
                placeholder="Enter URL"
                value={linkUrl}
                onChange={(e) => setLinkUrl(e.target.value)}
                style={{ width: 150 }}
              />
              <Button size="small" type="primary" onClick={setLink}>
                Add
              </Button>
              <Button size="small" onClick={unsetLink}>
                Remove
              </Button>
            </div>
          ) : (
            <Button
              type={editor.isActive("link") ? "primary" : "default"}
              size="small"
              onClick={() => setShowLinkInput(true)}
              title="Add Link"
            >
              🔗
            </Button>
          )}
        </div> */}

        {/* Media */}
        {/* <div className="flex items-center gap-1">
          <Button
            size="small"
            onClick={addImage}
            title="Insert Image"
            icon={<UploadOutlined />}
          >
            Image
          </Button>
        </div> */}
      </div>
    );
  };
  // < StatusBadge status = { s.name } color = { s.color || "#1890ff" } />
  // );

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const reorderedStatuses = Array.from(statuses);
    const [removed] = reorderedStatuses.splice(result.source.index, 1);
    reorderedStatuses.splice(result.destination.index, 0, removed);

    setStatuses(reorderedStatuses); // Update state
    localStorage.setItem(
      "statusOrder",
      JSON.stringify(reorderedStatuses.map((s) => s._id)),
    );
  };

  const fetchStatuses = async () => {
    try {
      const res = await getStatus();
      setStatuses(res.data);
      setoptionStatus(res.data || []);
    } catch (err) {
      console.error("Error fetching lead statuses", err);
      message.error("Failed to fetch lead statuses");
    }
  };

  const fetchSource = async () => {
    try {
      const getSource = await getAllSources("", page);
      if (getSource) {
        let filteredSource = getSource.sources.filter((item: any) =>
          item.category.includes("JobApplication"),
        );
        setSources(filteredSource);
      }
    } catch (error) {
      console.error("Error fetching source:", error);
    }
  };

  const statusOption = optionStatus.map((status: any) => ({
    value: status.slug,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div
          style={{
            width: "12px",
            height: "12px",
            backgroundColor: status.color,
            borderRadius: "2px",
          }}
        />
        <span>{status.name}</span>
      </div>
    ),
  }));

  // Function to close all dropdowns
  const closeAllDropdowns = () => {
    setDropdownsClosed((prev) => prev + 1);
  };

  useEffect(() => {
    fetchStatuses();
    fetchSource();
  }, []);

  const fetchJobApplications = async (filters?: any, targetPage?: number) => {
    try {
      setLoading(true);

      const mergedFilters = {
        ...currentFilters,
        ...(filters || {}),
      };
      setCurrentFilters(mergedFilters);

      const payload = {
        page: targetPage ?? page,
        limit: 10,
        search: searchText,
        timeFilter: mergedFilters.timeFilter,
        startDate: mergedFilters.startDate,
        endDate: mergedFilters.endDate,
        experianceStart: mergedFilters.experianceStart,
        experianceEnd: mergedFilters.experianceEnd,
        currentCTCMin: mergedFilters.currentCTCMin,
        currentCTCMax: mergedFilters.currentCTCMax,
        technology: mergedFilters.technology,
        source: mergedFilters.source ?? [],
        status: mergedFilters.jobApplicationStatus ?? [],
      };

      const response = await getAllJobApplications(payload);
      const formattedData = response.data.map((item: any) => ({
        ...item,
        key: item._id,
        status: Array.isArray(item.status)
          ? item.status
          : [item.status || "Pending"],
      }));

      setData(formattedData);
      setDataSource(formattedData);
      setFilteredData(formattedData);
      setTotalRecords(response.total || formattedData.length);
    } catch (error) {
      console.error("Error fetching job applications:", error);
      message.error("Failed to fetch job applications");
    } finally {
      setLoading(false);
    }
  };

  const fetchJobApplicationsFromWebsite = async () => {
    try {
      setLoading(true);

      // ✅ Call your backend API directly
      const response = await getJobapplicationFromWebsite();

      // ✅ Assuming backend returns { success: true, data: [...] }
      if (response?.success && Array.isArray(response.data)) {
        const formattedData = response.data.map((item: any) => ({
          ...item,
          key: item._id || item.id,
          status: Array.isArray(item.status)
            ? item.status
            : [item.status || "Pending"],
        }));

        // ✅ Update state
        setData(formattedData);
        setDataSource(formattedData);
        setFilteredData(formattedData);
        setTotalRecords(response.data.length);
      } else {
        message.warning("No job applications found");
      }
    } catch (error) {
      console.error("Error fetching job applications from website:", error);
      message.error("Failed to fetch job applications from website");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        // ✅ First call this function
        // await fetchJobApplicationsFromWebsite();
        // ✅ Then call your existing function
        await fetchJobApplications();
      } catch (err) {
        console.error("Error during initialization:", err);
        message.error("Failed to load job applications");
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [searchText, page]);

  const handleStatusChange = async (recordId: string, statusName: string) => {
    try {
      const newStatus = statuses.find((status) => status.name === statusName);
      if (!newStatus) {
        message.error("Selected status not found");
        return;
      }

      // Optimistic update in Redux
      dispatch(updateJobApplicationStatus({ recordId, newStatus: statusName }));

      // Backend update
      await updateJobApplication(recordId, { status: newStatus._id });

      // Fetch fresh applications from backend
      const refreshedData = await fetchJobApplications(undefined, page);
      // dispatch(setJobApplications(refreshedData));

      message.success(`Status updated to ${statusName}`);
    } catch (error: any) {
      console.error("Status update error:", error);
      message.error(error.message || "Failed to update status");

      // In case of error, refresh from backend to avoid stale UI
      const refreshedData = await fetchJobApplications(undefined, page);
      // dispatch(setJobApplications(refreshedData));
    }
  };

  // const handleMenuClick = (statusId: string) => {
  //   console.log(statusId)
  //   const selectedStatus = statuses.find((s) => s._id === statusId);
  //   if (selectedStatus) {
  //     // handleStatusChange(record._id, selectedStatus.name);
  //   }
  // };

  const getFileIcon = (fileName: string) => {
    const ext = fileName.split(".").pop()?.toLowerCase();

    if (ext === "pdf") {
      return (
        <FilePdfOutlined className="w-8 h-8 rounded-full text-xl mt-1.5 text-white mb-2 bg-gradient-to-br from-red-400 to-red-600 shadow-[0_4px_12px_rgba(239,68,68,0.3)] hover:shadow-[0_6px_16px_rgba(239,68,68,0.4)] active:translate-y-1 active:shadow-none flex items-center justify-center transition-all duration-200 group" />
      );
    }
    if (ext === "doc" || ext === "docx") {
      return (
        <FileWordOutlined className="w-8 h-8 rounded-full text-xl mt-1.5 text-white mb-2 bg-gradient-to-br from-blue-400 to-blue-600 shadow-[0_4px_12px_rgba(239,68,68,0.3)] hover:shadow-[0_6px_16px_rgba(239,68,68,0.4)] active:translate-y-1 active:shadow-none flex items-center justify-center transition-all duration-200 group" />
      );
    }
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext || "")) {
      return (
        <FileImageOutlined className="w-8 h-8 rounded-full text-xl mt-1.5 text-white mb-2 bg-gradient-to-br from-green-400 to-green-600 shadow-[0_4px_12px_rgba(239,68,68,0.3)] hover:shadow-[0_6px_16px_rgba(239,68,68,0.4)] active:translate-y-1 active:shadow-none flex items-center justify-center transition-all duration-200 group" />
      );
    }
    return (
      <FileUnknownOutlined className="w-8 h-8 rounded-full text-xl mt-1.5 text-white mb-2 bg-gradient-to-br from-gray-400 to-gray-600 shadow-[0_4px_12px_rgba(239,68,68,0.3)] hover:shadow-[0_6px_16px_rgba(239,68,68,0.4)] active:translate-y-1 active:shadow-none flex items-center justify-center transition-all duration-200 group" />
    );
  };

  const handleViewDescription = async (rawDataId: string) => {
    setCurrentDescriptionDataId(rawDataId);
    setDescriptionModalOpen(true);
    setDescriptionLoading(true);

    try {
      // ✅ Use your API function
      const res = await getSingleJobApplication(rawDataId);
      console.log(res);
      // assuming summaries are stored in `res.data.summaries`
      setdescriptionData(res?.data?.descriptions || []);
    } catch (err) {
      console.error("Error fetching summary:", err);
      setdescriptionData([]);
    } finally {
      setDescriptionLoading(false);
    }
  };

  const handleViewLogs = async (Id: string, page = 1, search = "") => {
    try {
      setCurrentLogId(Id);
      setIsLogModalOpen(true);
      setLogLoading(true);
      let type = "JobApplication";

      const data = await getRawDataLog(
        Id,
        page,
        logsPagination.pageSize,
        search,
        type,
      );

      setSelectedLogs(data.logs);
      setLogsPagination((prev) => ({
        ...prev,
        current: page,
        total: data.pagination.total,
        pageSize: data.pagination.pageSize,
      }));

      // scroll to top of modal
      setTimeout(() => {
        modalScrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    } catch (error) {
      console.error("Failed to fetch  logs:", error);
    } finally {
      setLogLoading(false);
    }
  };

  // JobApplicationPage.tsx
  useEffect(() => {
    if (!currentLogId) return;

    const timeout = setTimeout(() => {
      handleViewLogs(currentLogId, 1, logSearchText);
    }, 400); // run after 400ms pause

    return () => clearTimeout(timeout);
  }, [logSearchText, currentLogId]);

  const TwoLineClampWithTooltip = ({ text }: { text: string }) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
      const el = textRef.current;
      if (!el) return;

      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const maxHeight = lineHeight * 2;

      // Detect overflow
      if (el.scrollHeight > maxHeight + 1) {
        setIsOverflowing(true);
      } else {
        setIsOverflowing(false);
      }
    }, [text]);

    const content = (
      <div
        ref={textRef}
        className="line-clamp-2 text-gray-800 cursor-pointer"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );

    return isOverflowing ? (
      <Tooltip
        title={
          <div
            className="max-h-[250px] overflow-y-auto p-2"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        }
        placement="top"
        color="#CCCCCC"
        overlayInnerStyle={{
          color: "#000",
          padding: "12px",
          maxWidth: "500px",
          minWidth: "400px",
          maxHeight: "400px",
        }}
      >
        {content}
      </Tooltip>
    ) : (
      content
    );
  };

  const columns: ColumnType<JobApplication>[] = [
    {
      title: "#",
      key: "index",
      fixed: "left" as const,
      width: 60,
      render: (_: any, __: any, index: number) => (page - 1) * 10 + index + 1,
    },
    {
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      fixed: "left" as const,
    },
    {
      title: "Applied Date",
      dataIndex: "date",
      key: "date",
      fixed: "left" as const,
      render: (_: any, record: any) =>
        dayjs(record.date || record.createdAt).format("DD-MM-YYYY"),
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      fixed: "left" as const,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Position",
      dataIndex: "technology",
      key: "technology",
      render: (text?: string) => {
        if (!text) return <div className="text-gray-400">N/A</div>;

        const maxWords = 2; // set the number of words threshold
        const words = text.split(" ");
        const isLong = words.length > maxWords;
        const shortText = isLong
          ? words.slice(0, maxWords).join(" ") + "..."
          : text;

        return isLong ? (
          <Tooltip
            title={text}
            placement="top"
            color="#CCCCCC"
            overlayInnerStyle={{
              color: "#000",
              padding: "12px",
            }}
          >
            <div className="text-gray-800 hover:text-black cursor-pointer">
              {shortText}
            </div>
          </Tooltip>
        ) : (
          <div className="text-gray-800">{shortText}</div>
        );
      },
    },
    {
      title: "Source",
      key: "source",
      dataIndex: "source",
      render: (_: any, record: any) => {
        const source = record?.source;

        if (!source) return null;

        // If source is an object with name/color
        if (typeof record.source === "object" && source.name) {
          return (
            <SourceBadge
              key={record?.source._id || record._id}
              source={record?.source.name}
              color={record?.source.color}
            />
          );
        }

        // If source is an object WITHOUT name (malformed data) — render a fallback
        if (typeof source === "object") {
          return <SourceBadge key={record._id} source="Unknown" color="#ccc" />;
        }

        // If source is just a string
        return <SourceBadge key={source} source={source} color="#888" />;
      },
    },

    {
      title: "Total Experience",
      dataIndex: "total_experience",
      key: "total_experience",
      render: (text: number) => (
        <span className="px-2 py-1 rounded-xl text-xs bg-blue-100 text-blue-800">
          {text}
        </span>
      ),
    },
    {
      title: "Relevant Experience",
      dataIndex: "relevant_experience",
      key: "relevant_experience",
      render: (text: number) => (
        <span className="px-2 py-1 rounded-xl text-xs bg-green-100 text-green-800">
          {text}
        </span>
      ),
    },
    {
      title: "Current CTC",
      dataIndex: "current_ctc",
      key: "current_ctc",
      render: (text: number) => (
        <span className="px-2 py-1 rounded-xl text-xs bg-yellow-100 text-yellow-800">
          {text}
        </span>
      ),
    },
    {
      title: "Expected CTC",
      dataIndex: "expected_ctc",
      key: "expected_ctc",
      render: (text: number) => (
        <span className="px-2 py-1 rounded-2xl text-xs bg-purple-100 text-purple-800">
          {text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (
        status: { _id: string; name: string; color?: string } | undefined,
        record: any,
      ) => {
        // Build the menu dynamically for this row
        const menu = (
          <div
            className="p-2 bg-white shadow-lg rounded-md w-[180px] flex flex-col"
            style={{ maxHeight: 240 }}
          >
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="status-list">
                {(provided) => (
                  // Scrollable Status List
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="flex-1 overflow-y-auto mb-2"
                    style={{ maxHeight: 200 }} // optional, for fine control
                  >
                    {statuses.map((item, index) => (
                      <Draggable
                        key={item._id}
                        draggableId={item._id}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="p-1 hover:bg-gray-100 cursor-pointer flex items-center justify-between"
                            onClick={() =>
                              handleStatusChange(record._id, item.name)
                            }
                          >
                            {getStatusBadge(item)}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            {/* Fixed Add New Status Section */}
            <div className="border-t pt-2 mt-auto">
              {showAddStatus ? (
                <div className="flex flex-col gap-4">
                  <div className="flex items-center gap-2">
                    <Input
                      size="small"
                      value={newStatus}
                      onChange={(e) => setNewStatus(e.target.value)}
                      placeholder="Enter new status"
                      autoFocus
                      onPressEnter={handleAddStatus}
                      style={{ flex: 1, height: "50px" }}
                      className="Allinput"
                    />
                    <ColorPicker
                      size="small"
                      value={newStatusColor}
                      onChange={(color) =>
                        setNewStatusColor(color.toHexString())
                      }
                      onChangeComplete={(color) =>
                        setNewStatusColor(color.toHexString())
                      }
                      getPopupContainer={(trigger: any) =>
                        trigger.parentElement
                      }
                      style={{ padding: "5px" }}
                    />
                  </div>
                  <div className="flex justify-end gap-2">
                    <Button
                      size="small"
                      onClick={() => setShowAddStatus(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="small"
                      onClick={handleAddStatus}
                      disabled={!newStatus.trim()}
                      style={{ backgroundColor: "#001529", color: "white" }}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              ) : (
                <div
                  className="p-2 text-blue-500 hover:bg-gray-100 cursor-pointer flex items-center gap-1"
                  onClick={() => setShowAddStatus(true)}
                >
                  <PlusOutlined /> Add New Status
                </div>
              )}
            </div>
          </div>
        );

        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <span className="cursor-pointer">
              {status ? getStatusBadge(status) : <span>Select Status</span>}
            </span>
          </Dropdown>
        );
      },
    },

    {
      title: "Job Description",
      dataIndex: "jobDesc",
      key: "jobDesc",
      width: 200,
      render: (text?: string) => {
        if (!text) return <div className="text-gray-400">N/A</div>;
        return <TwoLineClampWithTooltip text={text} />;
      },
    },
    {
      title: "Description",
      key: "description",
      render: (_: any, record: any) => (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleViewDescription(record._id);
          }}
          className="w-7 h-7 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 shadow-[0_4px_12px_rgba(16,185,129,0.3)] hover:shadow-[0_6px_16px_rgba(16,185,129,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
          title="View Description" // This shows native tooltip instead of Antd Tooltip
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="group-hover:scale-110 transition-transform"
          >
            <path
              d="M4 6H20M4 12H20M4 18H11"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ),
    },
    {
      title: "Logs",
      key: "JobApplicationLog",
      render: (_: any, record: any) => (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleViewLogs(record._id);
          }}
          className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-400 to-blue-600 shadow-[0_4px_12px_rgba(96,165,250,0.3)] hover:shadow-[0_6px_16px_rgba(96,165,250,0.4)] active:translate-y-1 active:shadow-none text-white flex items-center justify-center transition-all duration-200 group"
          title="View Logs" // This shows native tooltip instead of Antd Tooltip
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="group-hover:scale-110 transition-transform"
          >
            <path
              d="M6 4V20M18 4V20M6 4H18M6 20H18M9 8H15M9 12H15M9 16H13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ),
    },
    {
      title: "Document",
      key: "resume",
      dataIndex: "resume",
      render: (_: unknown, record: JobApplication) => {
        const files = Array.isArray(record.resume)
          ? record.resume
          : [record.resume];
        const firstFile = files.find((file) => {
          const fileExtension = file.split(".").pop()?.toLowerCase();
          return [
            "jpg",
            "jpeg",
            "png",
            "gif",
            "webp",
            "pdf",
            "doc",
            "docx",
          ].includes(fileExtension || "");
        });

        if (!firstFile) {
          return <span>No document</span>;
        }

        const fileUrl = `${IMAGEURL}${firstFile}`;

        return (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="View Document"
          >
            {getFileIcon(firstFile)} {/* ✅ dynamic icon */}
          </a>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: JobApplication) => (
        <div className="d-flex" style={{ gap: "8px", alignItems: "center" }}>
          <button
            onClick={() => {
              closeAllDropdowns(); // Close dropdowns before opening edit modal
              editApplication(record);
            }}
            title="Edit"
            className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 
            shadow-[0_4px_12px_rgba(139,92,246,0.3)] 
            hover:shadow-[0_6px_16px_rgba(139,92,246,0.4)] 
            active:translate-y-[1px] active:shadow-none 
            text-white flex items-center justify-center 
            transition-all duration-200 ease-in-out group"
          >
            <FaPen
              className="group-hover:scale-110 transition-transform duration-200"
              size={12}
            />
          </button>

          {hasPermission("customers", "delete") && (
            <button
              onClick={() => {
                closeAllDropdowns(); // Close dropdowns before opening delete modal
                setDeleteId(record._id);
              }}
              title="Delete"
              className="w-7 h-7 rounded-full bg-gradient-to-br from-rose-500 to-rose-700 
              shadow-[0_4px_12px_rgba(244,63,94,0.3)] 
              hover:shadow-[0_6px_16px_rgba(244,63,94,0.4)] 
              active:translate-y-1 active:shadow-none 
              text-white flex items-center justify-center 
              transition-all duration-200 group"
            >
              <FaTrashAlt
                className="group-hover:scale-110 transition-transform"
                size={12}
              />
            </button>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    autoRegisterCurrentPageColumns(columns);
  }, []);

  const handleDelete = async () => {
    if (deleteId) {
      try {
        setLoading(true);
        await deleteJobApplication(deleteId);
        message.success("Application deleted successfully");
        await fetchJobApplications(undefined, page); // Pass current page
        setDeleteId(null);
      } catch (error) {
        message.error("Failed to delete application");
      } finally {
        setLoading(false);
      }
    }
  };

  const editApplication = (record: JobApplication) => {
    setCurrentTask(record);
    setIsEditModalVisible(true);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const handleDeleteDocument = async (doc: string, index: number) => {
    if (!selectedRecord) {
      message.error("No record selected");
      return;
    }

    try {
      const documentName = doc.split("/").pop() || "";
      await deleteJobDocumentImage(selectedRecord._id, documentName);
      message.success("Document deleted successfully");
      fetchJobApplications();
    } catch (error) {
      console.error("Error deleting document:", error);
      message.error("Failed to delete document");
    }
  };

  const resetSettings = () => {
    setSelectedSource([]);

    setTimeFilter(undefined);
    setStartDate(null);
    setEndDate(null);
    setTempStartDate(null);
    setShowRangePicker(false);

    setSelectedStatus([]);
    setFavName("");
    setError("");
  };

  const iconKeys = Object.keys(Icons).filter(
    (key) => key.endsWith("Outlined"), // only outlined icons (you can adjust)
  );
  const options = iconKeys.map((key) => {
    const IconComp = (Icons as any)[key];
    return {
      label: (
        <span>
          <IconComp style={{ marginRight: 8 }} /> {key}
        </span>
      ),
      value: key,
    };
  });

  const slugify = (text: string) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove special chars
      .replace(/\-\-+/g, "-");

  const applyFavouriteFilter = (fav: any) => {
    if (selectedFav === fav._id) {
      setSelectedFav(null);
      const defaultFilters = {
        jobApplicationStatus: [],
        timeFilter: undefined,
        startDate: null,
        endDate: null,
        source: [],
        technology: null,
        experianceStart: undefined,
        experianceEnd: undefined,
        currentCTCMin: undefined,
        currentCTCMax: undefined,
      };
      setCurrentFilters(defaultFilters);
      fetchJobApplications(defaultFilters);
      return;
    }

    setSelectedFav(fav._id);
    const favFilters = {
      jobApplicationStatus: fav.jobApplicationStatus || [],
      timeFilter: fav.time || undefined,
      startDate: fav.startDate
        ? dayjs(fav.startDate).format("YYYY-MM-DD")
        : undefined,
      endDate: fav.endDate
        ? dayjs(fav.endDate).format("YYYY-MM-DD")
        : undefined,
      source: fav.source || [],
      technology: fav.technology || null,
      experianceStart: fav.experiance?.start ?? undefined,
      experianceEnd: fav.experiance?.end ?? undefined,
      currentCTCMin: fav.currentCTC?.min ?? undefined,
      currentCTCMax: fav.currentCTC?.max ?? undefined,
    };

    setCurrentFilters(favFilters);
    setSelectedStatus(fav.jobApplicationStatus);
    setTimeFilter(fav.time);
    setStartDate(fav.startDate ? dayjs(fav.startDate) : null);
    setEndDate(fav.endDate ? dayjs(fav.endDate) : null);
    setSelectedSource(fav.source);
    setSelectedPosition(fav.technology);
    setStart(fav.experianceStart);
    setEnd(fav.experianceEnd);
    setMinCTC(fav.currentCTCMin);
    setMaxCTC(fav.currentCTCMax);
    setPage(1);

    fetchJobApplications(favFilters);
  };

  const FILTER_STORAGE_KEY = "JobApplicationFilter";

  const saveFavouriteFilters = (filters: any[]) => {
    try {
      // ✅ only save Analytics type filters
      const jobApplication = filters.filter(
        (f: any) => f.type === "JobApplication",
      );
      localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(jobApplication));
    } catch (error) {
      console.error("Failed to save favourite filters to localStorage", error);
    }
  };
  const getFavouriteFilters = (): any[] => {
    try {
      const saved = localStorage.getItem(FILTER_STORAGE_KEY);
      const parsed = saved ? JSON.parse(saved) : [];
      return parsed.filter((f: any) => f.type === "JobApplication");
    } catch (error) {
      console.error(
        "Failed to parse favourite filters from localStorage",
        error,
      );
      return [];
    }
  };

  const deleteFavouriteFilter = async (id: any) => {
    try {
      await deleteFilter(id);

      const filters = getFavouriteFilters().filter((f) => f._id !== id);
      saveFavouriteFilters(filters);
      setFavouriteFilters(filters);

      // ✅ reset selectedFav if deleted
      if (selectedFav === id) {
        setSelectedFav(null);
        localStorage.removeItem("selectedFavId");
      }

      message.success("Favourite filter deleted!");
    } catch (error) {
      console.error("Failed to delete filter:", error);
      message.error("Failed to delete favourite filter!");
    }
  };
  const saveFilterOrder = async (newOrder: any[]) => {
    try {
      const updatedFilters = newOrder.map((filter, index) => ({
        ...filter,
        orderId: index + 1,
      }));

      // 🔁 Update one by one
      await Promise.all(
        updatedFilters.map((f) =>
          updateFilter(f._id, { orderId: f.orderId, type: "JobApplication" }),
        ),
      );

      // ✅ Update local state + localStorage
      setFavouriteFilters(updatedFilters);
      saveFavouriteFilters(updatedFilters);
    } catch (error) {
      console.error("Failed to save filter order:", error);
    }
  };

  const onDragEndFilter = (result: any) => {
    if (!result.destination) return;

    const reordered = Array.from(favouriteFilters);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    saveFilterOrder(reordered); // 👈 updates backend + localStorage
  };
  const filterFetch = async () => {
    try {
      const localFilters = getFavouriteFilters(); // ✅ already only Analytics if you fixed earlier
      if (isDeveloper) {
        return;
      }

      const response = await getFilter(); // API call

      // ✅ filter server response by Analytics type
      const serverFilters = Array.isArray(response?.data)
        ? response.data.filter((res: any) => res.type === "JobApplication")
        : response?.data?.type === "JobApplication"
          ? [response.data]
          : [];

      // ✅ only keep filters for current user
      const userId = authData?.user?._id;
      const userFilters = serverFilters.filter(
        (sf: any) => sf.userId === userId,
      );

      // ✅ merge local + server (avoid duplicates by _id)
      const mergedFilters = [
        ...localFilters,
        ...userFilters.filter(
          (sf: any) => !localFilters.some((lf) => lf._id === sf._id),
        ),
      ];

      // ✅ save merged into localStorage
      saveFavouriteFilters(mergedFilters);
      setFavouriteFilters(mergedFilters);
    } catch (error) {
      console.error("Failed to fetch filters:", error);
    }
  };

  useEffect(() => {
    filterFetch();
  }, []);

  const addFavouriteFilter = async (fav: any) => {
    if (!fav.name.trim()) {
      setError("Please enter favorite name!");
      return;
    }
    setError("");

    const filters = getFavouriteFilters();

    const payload = {
      type: "JobApplication",
      userId: userId || null,
      icon: fav.icon || "",
      name: fav.name,
      source: Array.isArray(selectedSource)
        ? selectedSource
        : selectedSource
          ? [selectedSource]
          : [],
      jobApplicationStatus: Array.isArray(selectedStatus)
        ? selectedStatus
        : selectedStatus
          ? [selectedStatus]
          : [],
      time: timeFilter || null,
      startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
      // NEW FIELDS
      technology: selectedPosition || null, // bind your Select value
      experiance: { start: start || null, end: end || null }, // total experience
      currentCTC: { min: minCTC || null, max: maxCTC || null }, // CTC range
      isActive: true,
      isDeleted: false,
    };

    try {
      // send payload to backend
      const response = await addFilter(payload);

      // build slug (unique identifier for query params)
      const slug = fav.name.toLowerCase().replace(/\s+/g, "-");

      // build saved filter
      const savedFilter = {
        ...payload,
        _id: response.data?._id,
        slug,
      };

      // save in local storage / state
      // filters.push(savedFilter);
      const updatedFilters = [...filters, savedFilter];
      saveFavouriteFilters(updatedFilters);
      setFavouriteFilters(updatedFilters);

      message.success("Favourite filter saved!");
    } catch (error) {
      console.error("Failed to save filter:", error);
      message.error("Failed to save favourite filter!");
    }
  };

  const timeFilterOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "Last3Month", label: "Last 3 Month" },
    { value: "Last6Month", label: "Last 6 Month" },
    ...(startDate && endDate
      ? [
          {
            value: "custom",
            label: `${startDate.format("MMM D")} - ${endDate.format("MMM D")}`,
            startDate: startDate.format("DD-MM-YYYY"),
            endDate: endDate.format("DD-MM-YYYY"),
          },
        ]
      : [
          {
            value: "custom",
            label: "Custom Range",
            startDate: null,
            endDate: null,
          },
        ]),
  ];

  const JobApplicationMenu = (
    <div
      style={{
        display: "flex",
        maxWidth: "750px", // ⬅ increased width
        background: "linear-gradient(145deg, #ffffff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        overflow: "hidden",
        padding: "16px",
        gap: "20px",
        height: "85vh", // ⬅ increased height for modal
      }}
    >
      {/* -------- Favorites Section -------- */}
      <div
        style={{
          flex: 1,
          padding: "12px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          background: "#fff",
          overflowY: "auto", // ⬅ scroll if filters overflow
          maxHeight: "calc(85vh - 40px)",
        }}
      >
        <DragDropContext onDragEnd={onDragEndFilter}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <Table
                  dataSource={favouriteFilters}
                  rowKey={(record: any) => record._id || record.id} // ensure unique key
                  pagination={false}
                  size="small"
                  style={{ marginTop: "12px" }}
                  columns={[
                    {
                      title: "Favorites",
                      dataIndex: "name",
                      key: "name",
                      render: (_: any, record: any, index: number) => {
                        const IconComp = (Icons as any)[record.icon];
                        return (
                          <Draggable
                            draggableId={record._id}
                            index={index}
                            key={record._id}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  cursor: "grab",
                                  ...provided.draggableProps.style,
                                }}
                                onClick={() => applyFavouriteFilter(record)}
                              >
                                {IconComp && (
                                  <IconComp style={{ fontSize: "16px" }} />
                                )}
                                {/* <Tooltip
                                  title={record.name}
                                  color="#CCCCCC"
                                  overlayInnerStyle={{ color: "#000", padding: "12px" }}
                                > */}
                                <span
                                  style={{
                                    flex: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "200px",
                                  }}
                                >
                                  {record.name}
                                </span>
                                {/* </Tooltip> */}
                              </div>
                            )}
                          </Draggable>
                        );
                      },
                    },
                    {
                      title: "Action",
                      key: "action",
                      align: "center",
                      width: 80,
                      render: (_: any, record: any) => (
                        <Icons.DeleteOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteFavouriteFilter(record._id);
                          }}
                          style={{ color: "#ef4444", cursor: "pointer" }}
                        />
                      ),
                    },
                  ]}
                />
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      {/* -------- Filters Section -------- */}
      <div
        style={{
          padding: "12px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          background: "#fff",
          overflowY: "auto", // ⬅ scroll if filters overflow
          maxHeight: "calc(85vh - 40px)",
        }}
      >
        <h4
          style={{
            fontWeight: 600,
            fontSize: "16px",
            marginBottom: "12px",
            color: "#1f2937",
          }}
        >
          Filters
        </h4>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div style={{ display: "flex", gap: "8px" }}>
            {/* --- Icon Select --- */}
            <Tooltip
              title="Select an Icon"
              color="#CCCCCC"
              overlayInnerStyle={{
                color: "#000", // ✅ font color
                padding: "12px",
              }}
            >
              <Select
                style={{ width: 80, marginTop: "5px" }}
                showSearch
                placeholder="Select Icon"
                value={selectedIcon}
                onChange={(val) => setSelectedIcon(val)}
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
                onClick={(e) => e.stopPropagation()}
                options={options}
              />
              {/* {iconKeys.map((key) => {
                                    const IconComp = (Icons as any)[key];
                                    return (
                                        <Option key={key} value={key}>
                                            <IconComp style={{ marginRight: 8 }} /> {key}
                                        </Option>
                                    );
                                })} */}
              {/* </Select> */}
            </Tooltip>

            {/* --- Name Input --- */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Input
                placeholder="Enter favorite name"
                className="Allinput"
                value={favName}
                onChange={(e) => setFavName(e.target.value)}
              />
	              {error && (
	                <span
	                  style={{ color: "red", fontSize: "12px", marginTop: "16px" }}
	                >
	                  {getErrorMessage(error)}
	                </span>
	              )}
            </div>
            {/* --- Save Button --- */}
          </div>

          <Select
            placeholder="Select Source"
            mode="multiple"
            showSearch
            allowClear
            value={selectedSource}
            onChange={(val) => setSelectedSource(val)}
            optionFilterProp="label"
            filterOption={(input, option) =>
              typeof option?.label === "string" &&
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            options={sources.map((item: any) => ({
              value: item._id,
              label: item.name, // plain string (searchable)
              color: item.color, // metadata
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
            style={{ width: "100%" }}
            maxTagCount="responsive"
          />

          <Select
            style={{ width: "100%", height: "33px" }}
            value={timeFilter}
            onChange={(value, option) => {
              setTimeFilter(value);
              setPage(1);

              if (value === "custom") {
                if (
                  option &&
                  !Array.isArray(option) &&
                  (option as { startDate?: string; endDate?: string })
                    .startDate &&
                  (option as { startDate?: string; endDate?: string }).endDate
                ) {
                  // directly set range from option
                  setStartDate(
                    dayjs((option as { startDate: string }).startDate),
                  );
                  setEndDate(dayjs((option as { endDate: string }).endDate));
                } else {
                  // show picker if not yet selected
                  setShowRangePicker(true);
                }
              } else {
                setStartDate(null);
                setEndDate(null);
                setTempStartDate(null);
                setTempEndDate(null);
                setShowRangePicker(false);
              }
            }}
            placeholder="Select Time Filter"
            allowClear
            options={timeFilterOptions}
            optionLabelProp="label"
            dropdownRender={(menu) => (
              <div>
                {menu}
                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    style={{ color: "red" }}
                    onClick={() => {
                      setTimeFilter(undefined);
                      setStartDate(null);
                      setEndDate(null);
                      setTempStartDate(null);
                      setTempEndDate(null);
                      setShowRangePicker(false);
                    }}
                  >
                    Clear All Filters
                  </Button>
                </div>
              </div>
            )}
          />
          {showRangePicker && (
            <div
              style={{
                position: "fixed",
                top: "25%",
                left: "70%",
                transform: "translate(-50%, -50%)",
                zIndex: 1500,
                background: "#fff",
                padding: "16px",
                boxShadow:
                  "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <DatePicker.RangePicker
                value={
                  tempStartDate && tempEndDate
                    ? [tempStartDate, tempEndDate]
                    : null
                }
                onChange={(dates) => {
                  setTempStartDate(dates ? dates[0] : null);
                  setTempEndDate(dates ? dates[1] : null);
                }}
                format="YYYY-MM-DD"
                style={{ marginBottom: "16px", width: "100%" }}
                allowClear={false}
                getPopupContainer={(triggerNode) => document.body}
                popupStyle={{ zIndex: 2000 }} // make sure it’s above your box
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <Button
                  onClick={() => {
                    setShowRangePicker(false);
                    setTempStartDate(null);
                    setTempEndDate(null);
                    setTimeFilter(undefined);
                    setStartDate(null);
                    setEndDate(null);
                    setPage(1);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="allbuttons text-white deal-apply"
                  onClick={() => {
                    if (tempStartDate && tempEndDate) {
                      setStartDate(tempStartDate);
                      setEndDate(tempEndDate);
                      setShowRangePicker(false);
                      setPage(1);
                      setTimeFilter("custom");
                    }
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          )}

          <Select
            placeholder="Select Status"
            showSearch
            allowClear
            mode="multiple"
            value={selectedStatus} // bind state
            onChange={(val) => setSelectedStatus(val)} // update state
            optionFilterProp="label"
            filterOption={(input: any, option) =>
              (option?.label as any).toLowerCase().includes(input)
            }
            options={statuses.map((item: any) => ({
              value: item._id,
              label: item.name, // plain string (searchable)
              color: item.color, // metadata
            }))}
            optionRender={(option) => (
              <span style={{ color: option.data.color }}>
                {option.data.label}
              </span>
            )}
            style={{ width: "100%" }}
            maxTagCount="responsive"
          />
          {/* <Select placeholder="Position" className="CustomSelect"  >
            <Select.Option value="frontend">Frontend Developer</Select.Option>
            <Select.Option value="backend">Backend Developer</Select.Option>
            <Select.Option value="fullstack">Fullstack Developer</Select.Option>
            <Select.Option value="uiux"> UI/UX Designer</Select.Option>
            <Select.Option value="BDE">Business Development Executive</Select.Option>
          </Select> */}

          <Select
            value={selectedPosition}
            onChange={(val) => setSelectedPosition(val)}
            placeholder="Select Technology"
            className="CustomSelect"
            allowClear
            showSearch
            optionFilterProp="children"
            style={{ maxWidth: "300px" }} // adjust width
            filterOption={(input, option) =>
              String(option?.children || "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {allTechnologies.map((tech) => (
              <Select.Option key={tech} value={tech}>
                {tech}
              </Select.Option>
            ))}
          </Select>

          <div className="flex gap-2 items-center mt-1.5">
            <span className="text-gray-500">Total Experience :</span>

            <Select
              placeholder="From"
              value={start}
              allowClear
              onChange={(value) => setStart(value)}
              style={{ width: 80 }}
              options={optionsNumber.map((num) => ({ label: num, value: num }))}
            />

            <Select
              placeholder="To"
              value={end}
              allowClear
              onChange={(value) => setEnd(value)}
              style={{ width: 80 }}
              options={optionsNumber.map((num) => ({ label: num, value: num }))}
            />
          </div>

          <div className="flex gap-2 items-center mt-1.5">
            <span className="mr-4 text-gray-500">Current CTC : </span>
            <InputNumber
              placeholder="Min CTC"
              value={minCTC}
              min={0}
              onChange={(value: any) => setMinCTC(value)}
            />
            <InputNumber
              placeholder="Max CTC"
              value={maxCTC}
              min={0}
              onChange={(value: any) => setMaxCTC(value)}
            />
          </div>

          <div className="position-absolute right-6 bottom-5 flex justify-end items-end mt-1">
            {/* <Tooltip title="Save" color="#CCCCCC"
                  overlayInnerStyle={{
                    color: "#000",   // ✅ font color
                  }} > */}
            <button
              className="allsubmitebutton flex items-center justify-center"
              style={{
                width: "53px",
                height: "30px",
                borderRadius: "6px",
              }}
              type="submit"
              onClick={(e) => {
                e.stopPropagation();
                addFavouriteFilter({
                  name: favName,
                  icon: selectedIcon,
                });

                // clear after save
                setFavName("");
                setSelectedIcon("");
              }}
            >
              Save
            </button>
            {/* </Tooltip> */}
          </div>
        </div>
      </div>
    </div>
  );

  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    updateArrows();
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, []);
  // const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      // Scroll to bottom when new item added
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [descriptionData]);
  const scroll = (direction: "left" | "right") => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = 180; // width of one tab
    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const checkScroll = () => {
      const scrollEl = scrollRef.current;
      if (!scrollEl) return;

      setCanScrollLeft(scrollEl.scrollLeft > 0);
      setCanScrollRight(
        scrollEl.scrollWidth > scrollEl.clientWidth + scrollEl.scrollLeft,
      );
    };

    // Check initially
    checkScroll();

    // Optional: check on window resize
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [favouriteFilters]);

  useEffect(() => {
    const scrollEl = scrollRef.current;
    if (!scrollEl) return;

    const onScroll = () => {
      setCanScrollLeft(scrollEl.scrollLeft > 0);
      setCanScrollRight(
        scrollEl.scrollWidth > scrollEl.clientWidth + scrollEl.scrollLeft,
      );
    };

    scrollEl.addEventListener("scroll", onScroll);

    return () => scrollEl.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div>
      <Row
        className="m-2"
        align="middle"
        justify="space-between"
        gutter={[16, 16]}
      >
        {/* <Col xs={24} sm={20} md={4} lg={6} xl={4}>
          <h2 className="headername">Job Applications</h2>
        </Col> */}
        {/* Left side favourites */}
        <Col xs={16} sm={16} md={16} lg={14}>
          <div className="relative w-full flex items-center">
            {/* Left Arrow */}
            {canScrollLeft && (
              <div
                className="absolute left-0 z-10 flex items-center mt-[-13px] "
                onClick={() => scroll("left")}
              >
                <Icons.LeftOutlined className="text-gray-500 text-lg cursor-pointer" />
              </div>
            )}

            {/* Scrollable Tabs */}
            <div
              ref={scrollRef}
              className="flex overflow-x-auto scrollbar-hide w-full snap-x snap-mandatory"
              style={{ scrollBehavior: "smooth" }}
            >
              {favouriteFilters.map((f: any, index: number) => {
                const isActive = selectedFav === f._id;

                const maxWords = 2;
                const words = f.name.split(" ");
                const isLong = words.length > maxWords;
                const displayText = isLong
                  ? words.slice(0, maxWords).join(" ") + "..."
                  : f.name;

                const tabContent = (
                  <div
                    key={f._id}
                    onClick={() => applyFavouriteFilter(f)}
                    className={`flex-0 snap-start flex-shrink-0 text-center cursor-pointer font-medium px-2 py-2 whitespace-nowrap overflow-hidden text-ellipsis ${
                      isActive
                        ? "bg-[#001529] text-white"
                        : "bg-white text-gray-700"
                    }`}
                    style={{
                      width: "calc(100% / 5)", // Fit 3 tabs fully in view
                      minWidth: "0", // allow ellipsis
                      borderRight:
                        index !== favouriteFilters.length - 1
                          ? "1px solid #e5e7eb"
                          : "none",
                    }}
                  >
                    {displayText}
                  </div>
                );

                return isLong ? (
                  <Tooltip key={f._id} title={f.name}>
                    {tabContent}
                  </Tooltip>
                ) : (
                  tabContent
                );
              })}
            </div>

            {/* Right Arrow */}
            {canScrollRight && (
              <div
                className="absolute right-0 z-10 mt-[-13px] flex items-center"
                onClick={() => scroll("right")}
              >
                <Icons.RightOutlined className="text-gray-500 text-lg cursor-pointer" />
              </div>
            )}
          </div>
        </Col>
        <Col xs={8} sm={8} md={8} lg={10}>
          <div className="flex flex-wrap gap-2 w-full justify-between xs:justify-end sm:justify-end md:justify-end items-center">
            <div className="flex">
              <Input
                prefix={<SearchOutlined />}
                size="large"
                placeholder="Search..."
                allowClear
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                className="w-[200px] sm:w-48 md:w-56 lg:w-64"
                style={{
                  height: "35px",
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              />
              <Button
                icon={<FilterOutlined />}
                onClick={() => setJobApplicationModal(true)}
                style={{
                  height: "35px",
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              />
              <Modal
                style={{
                  bottom: 20,
                  top: 20,
                  // maxHeight: 'calc(100vh - 30px)',
                  margin: "0 auto",
                  position: "relative",
                }}
                styles={{
                  body: {
                    overflowY: "auto",
                    fontFamily: "inter, sans-serif",
                  },
                  header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                  },
                  content: {
                    padding: 0,
                    overflow: "hidden",
                  },
                }}
                title={
                  <div
                    style={{
                      color: "#4b5563",
                      fontFamily: "inter, sans-serif",
                      fontSize: "20px",
                      fontWeight: 500,
                    }}
                  >
                    JobApplication Favourite Filter
                  </div>
                }
                open={JobApplicationModal}
                onCancel={(e) => {
                  (e.stopPropagation(), setJobApplicationModal(false));
                  resetSettings();
                }}
                footer={null}
                width={650}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()} // also block submenu toggling
                >
                  {JobApplicationMenu}
                </div>
              </Modal>
            </div>
            <Tooltip title="Sync from Website">
              <Button
                onClick={fetchJobApplicationsFromWebsite}
                type="primary"
                className="allbuttons"
              >
                <RiRefreshLine className="button-icon" />
              </Button>
            </Tooltip>
            <Button
              type="primary"
              onClick={() => {
                closeAllDropdowns(); // Close dropdowns before opening add modal
                setIsAddTaskModalOpen(true);
              }}
              className="allbuttons"
            >
              <RiAddBoxFill className="button-icon" />
              <span className="button-text">Add</span>
            </Button>
            <AddJobApplicationModal
              visible={isAddTaskModalOpen}
              onClose={() => setIsAddTaskModalOpen(false)}
              onTaskCreated={() => {
                setIsAddTaskModalOpen(false);
                fetchJobApplications();
              }}
            />
          </div>
        </Col>
      </Row>
      <Card className="">
        <Spin spinning={loading}>
          <div
            className="scrollbar-hide custom-scroll-table"
            style={{ overflowX: "auto" }}
          >
            <Table
              scroll={{ x: "max-content" }}
              columns={columns}
              dataSource={filteredData}
              loading={loading}
              rowKey="_id"
              pagination={{
                pageSize: 10,
                current: page,
                onChange: (pageNumber) => setPage(pageNumber),
                showSizeChanger: false,
                total: totalRecords,
              }}
            />
          </div>
        </Spin>
      </Card>
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={800}
        className="custom-modal"
        style={{
          bottom: 20,
          top: 20,
          height: "60vh",
          margin: "0 auto",
          position: "relative",
        }}
        title={
          <div
            style={{
              marginLeft: "11px",
              width: "100%",
              paddingRight: 20,
            }}
          >
            Resume
          </div>
        }
        bodyStyle={{
          overflowY: "auto",
          fontFamily: "inter, sans-serif",
          height: "calc(100% - 55px)",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <div className="elements">
          {selectedRecord?.resume ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              {(() => {
                const items: React.ReactNode[] = [];
                let filePair: Array<{
                  doc: string;
                  fileUrl: string;
                  index: number;
                  isImage: boolean;
                }> = [];

                const files = Array.isArray(selectedRecord.resume)
                  ? selectedRecord.resume
                  : [selectedRecord.resume];

                files.forEach((doc: string, index: number) => {
                  const fileExtension = doc.split(".").pop()?.toLowerCase();
                  const isImage = [
                    "jpg",
                    "jpeg",
                    "png",
                    "gif",
                    "webp",
                  ].includes(fileExtension || "");
                  const isPDF = fileExtension === "pdf";
                  const fileUrl = `${IMAGEURL}${doc}`;

                  if (isImage || isPDF) {
                    filePair.push({ doc, fileUrl, index, isImage });

                    if (filePair.length === 2 || index === files.length - 1) {
                      items.push(
                        <div
                          key={`file-group-${index}`}
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            gap: "16px",
                            width: "100%",
                          }}
                        >
                          {filePair.map((file) => (
                            <div
                              key={`file-${file.index}`}
                              style={{
                                width: "50%",
                                padding: "12px",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                                boxSizing: "border-box",
                                height: "220px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  cursor: "pointer",
                                  background: "white",
                                  borderRadius: "50%",
                                  width: 24,
                                  height: 24,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                  zIndex: 1,
                                }}
                                onClick={() =>
                                  handleDeleteDocument(file.doc, file.index)
                                }
                              >
                                <DeleteOutlined style={{ color: "red" }} />
                              </div>
                              {file.isImage ? (
                                <a
                                  href={file.fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ width: "100%" }}
                                >
                                  <Image
                                    src={file.fileUrl}
                                    style={{
                                      width: "100%",
                                      height: "180px",
                                      objectFit: "contain",
                                      display: "block",
                                      borderRadius: "4px",
                                    }}
                                    preview={{ toolbarRender: () => <></> }}
                                  />
                                </a>
                              ) : (
                                <a
                                  href={file.fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    height: "180px",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textDecoration: "none",
                                  }}
                                >
                                  <FilePdfOutlined
                                    style={{ fontSize: 80, color: "#FF0000" }}
                                  />
                                  <span
                                    style={{
                                      marginTop: 10,
                                      fontSize: 14,
                                      color: "#666",
                                      textAlign: "center",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {file.doc}
                                  </span>
                                </a>
                              )}
                            </div>
                          ))}
                          {filePair.length === 1 && (
                            <div style={{ width: "50%" }} />
                          )}
                        </div>,
                      );
                      filePair = [];
                    }
                  }
                });
                return items;
              })()}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                minHeight: "200px",
                color: "rgba(0,0,0,0.45)",
              }}
            >
              <FileOutlined style={{ fontSize: "24px", marginRight: "8px" }} />
              No documents available
            </div>
          )}
        </div>
      </Modal>
      <Modal
        open={!!deleteId}
        onOk={handleDelete}
        onCancel={() => setDeleteId(null)}
        okText="Yes"
        cancelText="No"
        width={500}
        centered={false}
        destroyOnClose
        className="custom-modal"
        style={{
          bottom: 20,
          top: "10vw",
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        title={
          <div
            style={{
              marginLeft: "11px",
              width: "100%",
              paddingRight: 20,
            }}
          >
            Confirmation
          </div>
        }
        okButtonProps={{
          style: {
            backgroundColor: "#ff4d4f",
            borderColor: "#ff4d4f",
            color: "white",
          },
        }}
        bodyStyle={{
          padding: "22px",
          overflowY: "auto",
          fontFamily: "inter, sans-serif",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
          footer: {
            borderTop: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
        }}
      >
        <p>Are you sure you want to delete this Job Application?</p>
      </Modal>
      {/* Summary Modal */}
      <Modal
        title={
          <div className="flex justify-between items-center w-full">
            <span className="text-xl font-bold">Description</span>
          </div>
        }
        open={descriptionModalOpen}
        onCancel={() => setDescriptionModalOpen(false)}
        footer={null}
        width={650}
        getContainer={document.body}
        centered
        style={{
          top: 20,
          bottom: 20,
          // maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          // position: "relative",
        }}
        styles={{
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          body: {
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <Spin spinning={descriptionLoading}>
          <div className="elements relative">
            {/* 🔽 Scroll container */}
            <div
              ref={scrollRef}
              className="max-h-[400px] overflow-y-auto border border-gray-200 rounded-md"
              style={{
                position: "relative",
                overflowClipMargin: "content-box", // ✅ new CSS fix
                overflow: "auto",
                scrollBehavior: "smooth",
                zIndex: 0,
              }}
            >
              <table
                className="w-full bg-white border-collapse table-fixed"
                style={{ tableLayout: "fixed" }}
              >
                {/* Table Header */}
                <thead
                  className="sticky top-[-1px] bg-gray-200 z-20 shadow-md"
                  style={{
                    boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                  }}
                >
                  <tr>
                    <th className="border p-2 text-left w-[19%]">
                      <ClockCircleOutlined className="mr-2" /> Date
                    </th>
                    <th className="border p-2 text-left w-[35%]">
                      <MessageOutlined className="mr-2" /> Description
                    </th>
                    <th className="border p-2 text-left w-[20%]">
                      <ClockCircleOutlined className="mr-2" /> Next Action Date
                    </th>
                    <th className="border p-2 text-left w-[11%]">Action</th>
                  </tr>
                </thead>

                {/* Table Body */}
                <tbody className="align-center bg-white relative z-0">
                  {descriptionData.length > 0 ? (
                    descriptionData.map((description, idx) => {
                      const htmlContent = description.desc || "";
                      if (!htmlContent || htmlContent.trim() === "<p></p>") {
                        return (
                          <tr
                            key={idx}
                            className={`hover:bg-gray-100 transition`}
                          >
                            <td className="border p-2">{description?.date}</td>
                            <td className="border p-2 text-gray-400">
                              No description
                            </td>
                            <td className="border p-2">
                              {description?.nextActionDate}
                            </td>
                            <td className="border p-2 text-center">—</td>
                          </tr>
                        );
                      }

                      // Convert HTML to plain text for tooltip/preview logic
                      const tempDiv = document.createElement("div");
                      tempDiv.innerHTML = htmlContent;
                      const plainText =
                        tempDiv.textContent || tempDiv.innerText || "";
                      const needsTooltip =
                        plainText.length > 110 ||
                        htmlContent.includes("<li>") ||
                        overflowIndexes.includes(idx);

                      const previewContent = (
                        <div
                          ref={(el) => (previewRefs.current[idx] = el)}
                          dangerouslySetInnerHTML={{ __html: htmlContent }}
                          className="description-preview"
                        />
                      );

                      return (
                        <tr
                          key={idx}
                          className={`hover:bg-gray-100 transition ${descriptionData.length === 1 ? "h-[153px]" : ""} ${descriptionData.length === 2 ? "h-[80px]" : ""} ${descriptionData.length === 3 ? "h-[60px]" : ""}`}
                        >
                          <td className="border p-2">{description?.date}</td>
                          <td className="border p-2 break-words align-center">
                            {needsTooltip ? (
                              <div style={{ cursor: "pointer" }}>
                                <Tooltip
                                  title={
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: htmlContent,
                                      }}
                                      className="description-tooltip-content"
                                    />
                                  }
                                  mouseEnterDelay={0.3}
                                  classNames={{ root: "plain-tooltip" }}
                                  placement="top"
                                  // color="rgba(0, 0, 0, 0.75)"

                                  overlayStyle={{
                                    maxWidth: "500px",
                                    maxHeight: "400px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {previewContent}
                                </Tooltip>
                              </div>
                            ) : (
                              previewContent
                            )}
                          </td>
                          <td className="border p-2">
                            {description?.nextActionDate}
                          </td>
                          <td className="border p-2 text-center">
                            <DeleteOutlined
                              className="text-red-500 cursor-pointer hover:text-red-700"
                              onClick={async () => {
                                try {
                                  setDescriptionLoading(true);
                                  await deleteDescription(
                                    CurrentDescriptionDataId,
                                    description._id,
                                  );
                                  message.success(
                                    "Description deleted successfully",
                                  );
                                  const res = await getSingleJobApplication(
                                    CurrentDescriptionDataId,
                                  );
                                  setdescriptionData(
                                    res?.data?.descriptions || [],
                                  );
                                } catch (err) {
                                  message.error(
                                    //@ts-ignore
                                    err.response?.data?.message ||
                                      "Error deleting description",
                                  );
                                } finally {
                                  setDescriptionLoading(false);
                                }
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={4}
                        className="text-center p-4 text-gray-500 h-[155px]"
                      >
                        No Description found
                      </td>
                    </tr>
                  )}
                </tbody>

                {/* Sticky Add-New Row */}
                <tfoot className="sticky bottom-0 bg-white z-20 border-t shadow-[0_-2px_4px_rgba(0,0,0,0.05)]">
                  <tr className="align-top hover:bg-gray-50">
                    {/* ✅ DatePicker - Proper fit, no cut */}
                    <td className="border p-2 align-top w-[19%]">
                      <div className="relative w-full">
                        <DatePicker
                          value={newDescription.date}
                          format="DD-MM-YYYY"
                          onChange={(val) =>
                            setNewDescription({ ...newDescription, date: val })
                          }
                          allowClear
                          style={{
                            width: "100%",
                            background: "transparent",
                            // boxSizing: "border-box",
                            // height: "38px",
                            // lineHeight: "36px",
                            // display: "flex",
                            // alignItems: "center",
                            // justifyContent: "space-between",
                            // paddingRight: "28px", // ✅ space for the X icon
                          }}
                          className="custom-date"
                          // dropdownClassName="custom-datepicker-dropdown"
                        />
                      </div>
                    </td>

                    <td className="border p-2 align-top w-[50%]">
                      <Form.Item
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: "Please enter description",
                          },
                        ]}
                        style={{ marginBottom: 0 }}
                      >
                        <div className="border rounded bg-white">
                          <Toolbar />
                          <div
                            className="border rounded bg-white max-h-[120px] overflow-y-auto"
                            style={{
                              scrollbarWidth: "thin",
                              scrollbarColor: "#cbd5e1 #f1f5f9",
                            }}
                          >
                            <EditorContent
                              editor={editor}
                              className="outline-none min-h-[70px] max-h-[70px] p-2 break-words"
                              style={{
                                resize: "none",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                width: "100%",
                              }}
                            />
                          </div>
                        </div>
                      </Form.Item>
                    </td>

                    {/* ✅ Next Action Date - Same treatment */}
                    <td className="border p-2 w-[21%] align-top">
                      <div className="w-full flex items-center">
                        <DatePicker
                          format="DD-MM-YYYY"
                          onChange={(val) =>
                            setNewDescription({
                              ...newDescription,
                              nextActionDate: val,
                            })
                          }
                          allowClear
                          style={{
                            width: "100%",
                            background: "transparent",
                            // boxSizing: "border-box",
                            // height: "38px",
                            // lineHeight: "36px",
                            // display: "flex",
                            // alignItems: "center",
                            // justifyContent: "space-between",
                            // paddingRight: "28px",
                          }}
                          className="custom-date"
                        />
                      </div>
                    </td>

                    <td className="border p-2 text-center w-[10%] align-top">
                      <div className="text-gray-400">—</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div className="flex justify-end mt-3">
            <Button
              className="allbuttons"
              style={{
                color: "white",
                marginBottom: "10px",
                marginRight: "5px",
              }}
              onClick={async () => {
                // Check the editor content instead of newDescription.description
                if (!descValue?.trim() || descValue === "<p></p>") {
                  return message.error("Please enter a description");
                }

                const htmlContent = editor?.getHTML() || "";
                const plainText = editor?.getText().trim() || "";

                // Check if there's actual content
                if (
                  !plainText ||
                  plainText === "" ||
                  htmlContent === "<p></p>"
                ) {
                  return message.error("Please enter a description");
                }
                try {
                  setDescriptionLoading(true);
                  await updateJobApplication(CurrentDescriptionDataId, {
                    newDescription: {
                      nextActionDate:
                        newDescription.nextActionDate?.format("DD-MM-YYYY"),
                      description: htmlContent,
                      date: newDescription.date?.format("DD-MM-YYYY"),
                    },
                  });
                  message.success("Description added successfully");

                  // Reset editor and form
                  editor?.commands.clearContent();
                  setNewDescription({
                    date: dayjs(),
                    description: "",
                    nextActionDate: dayjs(),
                  });

                  // Refresh data
                  const res = await getSingleJobApplication(
                    CurrentDescriptionDataId,
                  );
                  setdescriptionData(res?.data?.descriptions || []);
                } catch (err: any) {
                  message.error(
                    err.response?.data?.message || "Error adding description",
                  );
                } finally {
                  setDescriptionLoading(false);
                }
              }}
            >
              Add Description
            </Button>
          </div>
        </Spin>
      </Modal>
      <Modal
        title={
          <div className="flex justify-between items-center w-full">
            <span className="text-xl font-bold">JobApplication Log</span>
            <Input
              placeholder="🔍 Search logs..."
              allowClear
              value={logSearchText}
              onChange={(e) => setLogSearchText(e.target.value)}
              className="w-64 rounded text-sm mr-10"
            />
          </div>
        }
        open={isLogModalOpen}
        onCancel={() => setIsLogModalOpen(false)}
        footer={null}
        width={650}
        style={{
          bottom: 20,
          top: 20,
          maxHeight: "calc(100vh - 30px)",
          margin: "0 auto",
          position: "relative",
        }}
        styles={{
          body: {
            overflowY: "auto",
            fontFamily: "inter, sans-serif",
          },
          header: {
            borderBottom: "1px solid #e0e0e0",
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <Spin spinning={logLoading}>
          <div ref={modalScrollRef} className="">
            <div className="elements">
              <table className="w-full bg-white shadow-md rounded-lg">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-3 text-left w-1/3">
                      <ClockCircleOutlined className="mr-2" /> Updated At
                    </th>
                    <th className="border p-3 text-left">
                      <MessageOutlined className="mr-2" /> Message
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedLogs.length > 0 ? (
                    selectedLogs.map((log) => {
                      const formattedTimestamp = dayjs(log.createdAt)
                        .utc()
                        .local()
                        .format("DD-MM-YYYY HH:mm");

                      // Create temporary element to convert HTML to text for word counting
                      const tempDiv = document.createElement("div");
                      tempDiv.innerHTML = log.message;
                      const plainText =
                        tempDiv.textContent || tempDiv.innerText || "";
                      const words = plainText.split(" ");
                      const isLong = words.length > 12;
                      const displayText = isLong
                        ? words.slice(0, 12).join(" ") + "..."
                        : plainText;

                      return (
                        <tr
                          key={log._id}
                          className="hover:bg-gray-100 transition"
                        >
                          <td className="border p-3">{formattedTimestamp}</td>
                          <td className="border p-3 max-w-xl">
                            {isLong ? (
                              <Tooltip
                                title={
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: log.message,
                                    }}
                                    className="description-tooltip-content"
                                  />
                                }
                                mouseEnterDelay={0.3}
                                classNames={{ root: "plain-tooltip" }}
                                placement="top"
                                color="#CCCCCC"
                                overlayStyle={{
                                  maxWidth: "500px",
                                  maxHeight: "400px",
                                  overflowY: "auto",
                                }}
                              >
                                <div
                                  style={{
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical" as const,
                                    WebkitLineClamp: 2,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    maxWidth: "350px",
                                    cursor: "pointer",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      log.message.length > 110
                                        ? log.message.substring(0, 110) + "..."
                                        : log.message,
                                  }}
                                />
                              </Tooltip>
                            ) : (
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical" as const,
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  maxWidth: "350px",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: log.message,
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={2}
                        className="border p-3 text-center text-gray-500"
                      >
                        No logs available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="footer-modals" />
            <div className="p-3">
              <div className="d-flex justify-content-end">
                <Pagination
                  current={logsPagination.current}
                  pageSize={logsPagination.pageSize}
                  total={logsPagination.total}
                  onChange={(page) => {
                    if (currentLogId) {
                      handleViewLogs(currentLogId, page, logSearchText);
                    }
                  }}
                  showSizeChanger={false}
                />
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
      {currentTask && (
        <EditJobApplicationModal
          visible={isEditModalVisible}
          customerId={currentTask?._id}
          onClose={() => setIsEditModalVisible(false)}
          onSuccess={fetchJobApplications}
        />
      )}
    </div>
  );
};

export const JOB_APPLICATIONS_TABLE_COLUMNS = [
  "full_name",
  "date",
  "phone_number",
  "email",
  "city",
  "technology",
  "source",
  "status",
];

export default JobApplicationPage;
